"use client";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { useEffect } from "react";
import { useRouter } from "next/navigation";
import LoadingScreen from "../components/layout/Loading";

export default function PlaybackLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const router = useRouter();

  useEffect(() => {
    if (authStatus === "unauthenticated") {
      router.push("/login");
    }
  }, [authStatus, router]);

  useEffect(() => {
    // Load IVS Player SDK
    const script = document.createElement("script");
    script.src = "https://player.live-video.net/1.26.0/amazon-ivs-player.min.js";
    script.async = true;
    document.head.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  if (authStatus === "configuring") {
    return <LoadingScreen />;
  }

  if (authStatus === "unauthenticated") {
    return <LoadingScreen />;
  }

  return <div className="h-full">{children}</div>;
}
